import {
  ChakraProvider,
  Box,
  VStack,
  Grid,
  theme,
} from '@chakra-ui/react';
import Header from './components/Header';
import DoorItem from './components/DoorItem';
import DoorContextProvider from './components/context/DoorContext';
import EmergencyButtons from './components/EmergencyButtons';
import AccessLogCard from './components/AccessLogCard';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom"
import RootLayout from './components/pages/RootLayout';
import LoginPage from './components/pages/LoginPage';
import Dashboard from './components/pages/Dashboard';
import LogPage from './components/pages/LogPage';
import AdminPage from './components/pages/AdminPage';
import DataPage from './components/pages/DataPage';
import CardGroupPage from './components/pages/CardGroupPage';
import DoorAdminPage from './components/pages/DoorAdminPage';
import DoorTimePage from './components/pages/DoorTimePage';
import DoorsWithIp from './components/pages/DoorsWithIp';



const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <h1>Error</h1>,
    children: [
      { index: true, element: <Dashboard/> },
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "/logs",
        element: <LogPage />,
      },
      {
        path: "/admin",
        element: <AdminPage />,
      },
      {
        path: "/cards",
        element: <DataPage />,
      },
      {
        path: "/cardgroups",
        element: <CardGroupPage />,
      },
      {
        path: "/dooradmin",
        element: <DoorAdminPage />,
      },
      {
        path: "/doortime",
        element: <DoorTimePage />,
      },
      {
      path: "/durys-su-ip",
      element: <DoorsWithIp />,
    },
      
    ],
  },
])


function App() {

   
 
  
  return (
    <ChakraProvider theme={theme}>
      <DoorContextProvider>
      
      <RouterProvider router={router} />
      
      </DoorContextProvider>
    </ChakraProvider>
  );
}

export default App;
